import {Action, createAction, props} from '@ngrx/store';
import {IYear} from '../models/IYearModel';
import {IStates} from '../models/IStatesModel';
import {ICountyModel} from '../models/ICountyModel';
import {ICommodities} from '../models/ICommodityModel';

export enum FormFilterActionTypes {
  UPDATE_YEAR = '[IFormFilter] Update Year',
  UPDATE_STATE = '[IFormFilter] Update State',
  UPDATE_COUNTY = '[IFormFilter] Update County',
  UPDATE_COMMODITY = '[IFormFilter] Update Crop',
  UPDATE_PLAN = '[IFormFilter] Update Plan'
}

export const UpdateYearAction = createAction(
  FormFilterActionTypes.UPDATE_YEAR,
  props<{ year: IYear }>()
);


export const UpdateStateAction = createAction(
  FormFilterActionTypes.UPDATE_STATE,
  props<{ state: IStates }>()
);

export const UpdateCountyAction = createAction(
  FormFilterActionTypes.UPDATE_COUNTY,
  props<{ county: ICountyModel }>()
);


export const UpdateCommodityAction = createAction(
  FormFilterActionTypes.UPDATE_COMMODITY,
  props<{ commodity: ICommodities }>()
);
